<template>
    <div>
        <stages-template :data="{ all: data }" @onClickStage="onClickStage" />
    </div>
</template>

<script>
import i18n from '@/i18n'
import Swal from 'sweetalert2'
import notification, { success, danger } from '@/lib/notification'
import StagesTemplate from '../components/stages-template'
import { updateUsersStage } from './api'

notification.init()

export default {
    name: 'ChangeUsersStage',
    props: ['data', 'selectedUsers', 'canChangeUsersStage'],
    components: {
        StagesTemplate,
    },
    methods: {
        onClickStage(stageID) {
            if (!this.canChangeUsersStage) {
                Swal({
                    type: 'warning',
                    title: i18n.t('people.onlyAdminsCanChangeUsersStage'),
                    cancelButtonText: i18n.t(`modal.close`),
                    showCancelButton: true,
                    showConfirmButton: false,
                })
            } else {
                const selectedStage = this.data.find(
                    (stage) => stage.id === stageID
                )
                Swal({
                    text: i18n.t('stages.confirmToChangeUsersStage', {
                        stage: selectedStage.title,
                    }),
                    type: 'warning',
                    title: i18n.t('notification.areYouSure'),
                    confirmButtonText: i18n.t('notification.yes'),
                    cancelButtonText: i18n.t('notification.no'),
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return updateUsersStage(this.selectedUsers, stageID)
                            .then((resp) => {
                                this.$emit('updated', resp)
                                success(
                                    i18n.t('notification.updatedSuccessfully', {
                                        item: i18n.t('stages.stage'),
                                    })
                                )
                            })
                            .catch(() => {
                                danger()
                            })
                    },
                })
            }
        },
    },
}
</script>
